export interface CellRegionalPair {
  cell: number;
  regional: number;
}

export const CELL_REGIONAL_TRACEABILITY: CellRegionalPair[] = [
  { cell: 26, regional: 92 },
  { cell: 26, regional: 92 },
  { cell: 23, regional: 92 },
  { cell: 25, regional: 92 },
  { cell: 21, regional: 92 },
  { cell: 26, regional: 92 },
  { cell: 24, regional: 92 },
  { cell: 26, regional: 92 },
  { cell: 24, regional: 92 },
  { cell: 24, regional: 92 },
  { cell: 21, regional: 92 },
  { cell: 23, regional: 92 },
  { cell: 24, regional: 92 },
  { cell: 25, regional: 92 },
  { cell: 25, regional: 92 },
  { cell: 26, regional: 92 },
  { cell: 23, regional: 92 },
  { cell: 26, regional: 92 },
  { cell: 21, regional: 92 },
  { cell: 24, regional: 92 },
  { cell: 21, regional: 92 },
  { cell: 22, regional: 92 },
  { cell: 23, regional: 92 },
  { cell: 24, regional: 92 },
  { cell: 23, regional: 92 },
  { cell: 25, regional: 92 },
  { cell: 22, regional: 92 },
  { cell: 23, regional: 92 },
  { cell: 25, regional: 92 },
  { cell: 24, regional: 92 },
  { cell: 26, regional: 92 },
  { cell: 25, regional: 92 },
  { cell: 24, regional: 92 },
  { cell: 22, regional: 92 },
  { cell: 23, regional: 92 },
  { cell: 24, regional: 92 },
  { cell: 26, regional: 92 },
  { cell: 21, regional: 92 },
  { cell: 25, regional: 92 },
  { cell: 22, regional: 92 },
  { cell: 22, regional: 92 },
  { cell: 22, regional: 92 },
  { cell: 21, regional: 92 },
  { cell: 24, regional: 92 },
  { cell: 22, regional: 92 },
  { cell: 34, regional: 93 },
  { cell: 33, regional: 93 },
  { cell: 32, regional: 93 },
  { cell: 32, regional: 93 },
  { cell: 31, regional: 93 },
  { cell: 33, regional: 93 },
  { cell: 32, regional: 93 },
  { cell: 32, regional: 93 },
  { cell: 31, regional: 93 },
  { cell: 31, regional: 93 },
  { cell: 31, regional: 93 },
  { cell: 33, regional: 93 },
  { cell: 31, regional: 93 },
  { cell: 34, regional: 93 },
  { cell: 34, regional: 93 },
  { cell: 33, regional: 93 },
  { cell: 34, regional: 93 },
  { cell: 34, regional: 93 },
  { cell: 32, regional: 93 },
  { cell: 31, regional: 93 },
  { cell: 32, regional: 93 },
  { cell: 33, regional: 93 },
  { cell: 34, regional: 93 },
  { cell: 32, regional: 93 },
  { cell: 34, regional: 93 },
  { cell: 31, regional: 93 },
  { cell: 32, regional: 93 },
  { cell: 34, regional: 93 },
  { cell: 32, regional: 93 },
  { cell: 31, regional: 93 },
  { cell: 34, regional: 93 },
  { cell: 32, regional: 93 },
  { cell: 32, regional: 93 },
  { cell: 33, regional: 93 },
  { cell: 31, regional: 93 },
  { cell: 44, regional: 94 },
  { cell: 45, regional: 94 },
  { cell: 44, regional: 94 },
  { cell: 41, regional: 94 },
  { cell: 43, regional: 94 },
  { cell: 43, regional: 94 },
  { cell: 45, regional: 94 },
  { cell: 45, regional: 94 },
  { cell: 42, regional: 94 },
  { cell: 43, regional: 94 },
  { cell: 42, regional: 94 },
  { cell: 41, regional: 94 },
  { cell: 45, regional: 94 },
  { cell: 45, regional: 94 },
  { cell: 42, regional: 94 },
  { cell: 44, regional: 94 },
  { cell: 42, regional: 94 },
  { cell: 44, regional: 94 },
  { cell: 43, regional: 94 },
  { cell: 41, regional: 94 },
  { cell: 44, regional: 94 },
  { cell: 44, regional: 94 },
  { cell: 45, regional: 94 },
  { cell: 44, regional: 94 },
  { cell: 41, regional: 94 },
  { cell: 41, regional: 94 },
  { cell: 42, regional: 94 },
  { cell: 42, regional: 94 },
  { cell: 42, regional: 94 },
  { cell: 45, regional: 94 },
  { cell: 43, regional: 94 },
  { cell: 44, regional: 94 },
  { cell: 43, regional: 94 },
  { cell: 43, regional: 94 },
  { cell: 41, regional: 94 },
  { cell: 45, regional: 94 },
  { cell: 43, regional: 94 },
  { cell: 44, regional: 94 },
  { cell: 43, regional: 94 },
  { cell: 52, regional: 95 },
  { cell: 53, regional: 95 },
  { cell: 51, regional: 95 },
  { cell: 52, regional: 95 },
  { cell: 53, regional: 95 },
  { cell: 51, regional: 95 },
  { cell: 52, regional: 95 },
  { cell: 52, regional: 95 },
  { cell: 53, regional: 95 },
  { cell: 51, regional: 95 },
  { cell: 52, regional: 95 },
  { cell: 52, regional: 95 },
  { cell: 52, regional: 95 },
  { cell: 53, regional: 95 },
  { cell: 52, regional: 95 },
  { cell: 53, regional: 95 },
  { cell: 51, regional: 95 },
  { cell: 51, regional: 95 },
  { cell: 53, regional: 95 },
  { cell: 53, regional: 95 },
  { cell: 52, regional: 95 },
  { cell: 52, regional: 95 },
  { cell: 52, regional: 95 },
  { cell: 51, regional: 95 },
  { cell: 53, regional: 95 },
  { cell: 51, regional: 95 },
  { cell: 51, regional: 95 },
  { cell: 52, regional: 95 },
];


export const getRegionalsByCel = (cell: number): number[] => {
  return [
    ...new Set(
      CELL_REGIONAL_TRACEABILITY.filter((pair) => pair.cell === cell).map(
        (pair) => pair.regional
      )
    ),
  ].sort((a, b) => a - b);
};

export const getCellsByRegional = (regional: number): number[] => {
  return [
    ...new Set(
      CELL_REGIONAL_TRACEABILITY.filter((pair) => pair.regional === regional).map(
        (pair) => pair.cell
      )
    ),
  ].sort((a, b) => a - b);
};

export const getAllCells = (): number[] => {
  return [
    ...new Set(CELL_REGIONAL_TRACEABILITY.map((pair) => pair.cell)),
  ].sort((a, b) => a - b);
};


export const getAllRegionals = (): number[] => {
  return [
    ...new Set(CELL_REGIONAL_TRACEABILITY.map((pair) => pair.regional)),
  ].sort((a, b) => a - b);
};


export const isValidCellRegionalPair = (
  cell: number,
  regional: number
): boolean => {
  return CELL_REGIONAL_TRACEABILITY.some(
    (pair) => pair.cell === cell && pair.regional === regional
  );
};
